import React, { useEffect, useState } from 'react';
import { injectIntl } from 'react-intl';
import { InputAdornment, TextField } from '@mui/material';
import NumberFormat from 'react-number-format';

// v9: MUI's Input passes a ref to inputComponent — must be forwardRef-aware,
// otherwise we get the "inputComponent does not correctly handle the `ref` prop" warning.
// react-number-format v4 exposes its inner <input> ref via getInputRef.
const NumberFormatWrapper = React.forwardRef(function NumberFormatWrapper(props, ref) {
  const { onChange, ...rest } = props;
  return (
    <NumberFormat
      {...rest}
      getInputRef={ref}
      decimalSeparator="."
      thousandSeparator=","
      inputMode="decimal"
      pattern="[0-9],*"
      onValueChange={values => {
        onChange({
          target: {
            name: props.name,
            value: values.value !== '' ? parseFloat(values.value) : undefined
          }
        });
      }}
    />
  );
});

const CurrentAssetInput = props => {
  const { intl, value, onFocus, onValueChange, startAdornmentLabel, ...rest } = props;

  const [internalValue, setInternalValue] = useState(value);

  useEffect(() => {
    setInternalValue(value);
  }, [value]);

  return (
    <TextField
      className="analysis-input"
      name="currentAsset"
      label={intl.formatMessage({ id: 'Current Asset' })}
      value={internalValue}
      onChange={event => {
        setInternalValue(event.target.value);
      }}
      type="text"
      slotProps={{
        inputLabel: { shrink: true },
        input: {
          inputComponent: NumberFormatWrapper,
          inputProps: {
            allowNegative: false,
            decimalScale: 1,
            isAllowed: values => {
              const { formattedValue, value } = values;
              return formattedValue === '' || value;
            },
            onBlur: event => {
              if (onValueChange !== undefined) {
                onValueChange({ target: { value: internalValue } });
              }
            }
          },
          startAdornment:
            startAdornmentLabel !== undefined ? (
              <InputAdornment position="start">{startAdornmentLabel}</InputAdornment>
            ) : (
              undefined
            ),
          className: 'analysis-input-text'
        }
      }}
    />
  );
};

export default injectIntl(CurrentAssetInput);
